import React from "react";
import Button from "./button";
const Card = (props) => {
  const { title, blog, author, createdon } = props.cardProps;
  return (
    <div className="w-64 h-64 bg-slate-200 m-4 border-solid border-2  rounded-md relative  ">
      <h1 className="text-red-600">{title}</h1>
      <p>{blog}</p>
      <p>Author: {author}</p>
      {/* <Button name={"Delete Blog"} className="text-red" /> */}
      <button className="w-full bg-red-500 px-4 py-2 absolute bottom-0 rounded-md">
        Delete blog
      </button>
    </div>
  );
};

export default Card;
